@if (!loading && sharedService.urlParams) {
  @if (!customerGuidMissing) {
    <bi-skip-link skipToId="main-content" [label]="'accessibility.GoMainContent' | translate" (onClick)="onSkipToMainContentClicked()" />
    <div [class.blur]="showDisclaimer()">
      <div class="subscription-panel">
        <div class="p-panel p-component">
          <div class="p-panel-header w-12 block">
            <div id="header-container">
              <h1 class="header m-0">{{ title() }}</h1>
              @if (!sharedService.urlParams.hideBackBtn) {
                <bi-subscription-module-reset-button (onClick)="onReset()" />
              }
            </div>
          </div>
          <main>
            <!-- Container with the 3 steps switching with a slide effect -->
            <div class="p-panel-content p-3" data-uitest="background-color">
              <div
                class="slide-container"
                [ngClass]="{
                  'slide-2': currentStep() === 2,
                  'slide-3': currentStep() === 3
                }"
              >
                <div class="slideable-content flex" id="main-content">
                  <div class="push-up-container" [class.push-up]="showEnterPinArea">
                    <!-- STEP 1 - CONTACT DETAILS -->
                    <div class="contact-info-container">
                      <p class="sub-header mb-3 font-normal enter-contact-info-text">
                        {{ subHeaderTranslationKey() | translate }}
                      </p>
                      <!-- Subscriber details -->
                      @if (mobileEmailForm) {
                        <form [formGroup]="mobileEmailForm" class="grid bi-p-fluid justify-content-center">
                          <!-- mobile -->
                          <div class="col-12">
                            <bi-phone-input
                              data-uitest="mobile"
                              id="mobile"
                              #phoneInput
                              [onlyMainCountries]="true"
                              [countryId]="sharedService.countryId"
                              formControlName="mobile"
                              [focusable]="currentStep() === 1"
                              [canSelectCountryCode]="true"
                              [attr.aria-invalid]="mobileCtrl.invalid"
                            />
                            <div role="alert">
                              @if (mobileCtrl.errors?.atLeast1Required && mobileCtrl.dirty) {
                                <p class="field-error mb-2">
                                  {{ atLeast1RequiredMessage | translate }}
                                </p>
                              }
                            </div>
                          </div>
                          <!-- landline -->

                          @if (sharedService.urlParams.showLandline) {
                            <div class="col-12">
                              <bi-phone-input
                                id="subscribeUnsubscribeIframeLandline"
                                data-uitest="landline"
                                [countryId]="sharedService.countryId"
                                #phoneInputVoice
                                [onlyMainCountries]="true"
                                [label]="'shared.CountryCodeAndLandline' | translate"
                                [isLandLine]="true"
                                [focusable]="currentStep() === 1"
                                [canSelectCountryCode]="true"
                                formControlName="landline"
                                [attr.aria-invalid]="landlineCtrl.invalid"
                              />
                              <div role="alert">
                                @if (landlineCtrl.errors?.atLeast1Required && landlineCtrl.dirty) {
                                  <p class="field-error mb-2" translate>
                                    {{ atLeast1RequiredMessage | translate }}
                                  </p>
                                }
                              </div>
                            </div>
                          }
                          <!-- EMAIL -->
                          @if (!sharedService.urlParams.hideEmailInput) {
                            <div class="col-12">
                              <label class="FieldLabel" for="email-field" translate>shared.Email</label>
                              <input
                                type="email"
                                id="email-field"
                                data-uitest="email"
                                autocomplete="email"
                                pInputText
                                [tabindex]="currentStep() === 1 ? 0 : -1"
                                formControlName="email"
                                [placeholder]="'shared.EnterEmail' | translate"
                                [attr.aria-invalid]="emailCtrl.invalid"
                                [attr.aria-label]="'shared.Email' | translate"
                                [attr.aria.hidden]="currentStep() === 1 ? 0 : -1"
                                [title]="'shared.Email' | translate"
                                maxlength="100"
                              />
                              <div role="alert" aria-atomic="true">
                                @if (emailCtrl.invalid && emailCtrl.dirty) {
                                  @if (emailCtrl.errors.email) {
                                    <p class="field-error mb-2" translate>errorMessages.emailInvalid</p>
                                  }
                                  @if (emailCtrl.errors.atLeast1Required) {
                                    <p class="field-error mb-2">
                                      {{ atLeast1RequiredMessage | translate }}
                                    </p>
                                  }
                                }
                              </div>
                            </div>
                          }

                          <!-- NAME -->
                          <div class="col-12">
                            <label class="FieldLabel" for="name" translate>shared.Name</label>
                            <input
                              id="name"
                              data-uitest="name"
                              autocomplete="name"
                              pInputText
                              [attr.aria-label]="'shared.Name' | translate"
                              title="{{ 'shared.Name' | translate }}"
                              [tabindex]="currentStep() === 1 ? 0 : -1"
                              [attr.aria.hidden]="currentStep() === 1 ? 0 : -1"
                              formControlName="name"
                              [placeholder]="'shared.EnterName' | translate"
                            />
                          </div>
                          <!-- CAPTCHA (using aria-live for screen readers) -->
                          <div [class.col-12]="showCaptcha" aria-live="assertive">
                            @if (showCaptcha) {
                              <div @fadeIn>
                                <p class="cdk-visually-hidden" translate>accessibility.SecurityControl</p>
                                <re-captcha #recaptcha formControlName="recaptcha" (resolved)="onCaptchaResolved($event)" />
                              </div>
                            }
                          </div>
                          <div class="col-12">
                            <button
                              pButton
                              data-uitest="send-pincode"
                              class="primary-wcag mt-4 mb-1 col-12 send-pin-button"
                              [fluid]="true"
                              type="submit"
                              [tabindex]="currentStep() === 1 ? 0 : -1"
                              [disabled]="mobileEmailForm.invalid || mobileEmailForm.pristine"
                              [ariaLabel]="(sharedService.urlParams.disableAuth ? 'OK' : 'iFrame.Subscription.SendPinCode') | translate"
                              [label]="(sharedService.urlParams.disableAuth ? 'OK' : 'iFrame.Subscription.SendPinCode') | translate"
                              (click)="onOkOrSendCodeClicked()"
                            ></button>
                          </div>
                        </form>
                      }

                      @if (requestingPinCode) {
                        <bi-spinner [centerInParent]="true" [onTopOfContainer]="true" [hasBackground]="true" />
                      }
                    </div>
                    <!-- PIN CODE AREA -->
                    @if (showEnterPinArea && sharedService.urlParams && !sharedService.urlParams.disableAuth) {
                      <div class="enter-pin-area">
                        <p class="mb-2" translate>
                          {{ sharedService.urlParams.hideEmailInput ? "iFrame.Subscription.PinSentEnterBelowNoEmail" : "iFrame.Subscription.PinSentEnterBelow" }}
                        </p>
                        <input
                          type="text"
                          #pinInput
                          class="w-6 md:w-4 lg:w-2 xl:w-1"
                          maxlength="4"
                          pInputText
                          min="1000"
                          max="9999"
                          [tabindex]="currentStep() === 1 ? 0 : -1"
                          [attr.aria-invalid]="pinCodeCtrl.invalid && pinCodeCtrl.dirty"
                          [placeholder]="'shared.EnterPinCode' | translate"
                          [attr.aria-label]="'shared.PinCode' | translate"
                          [formControl]="pinCodeCtrl"
                          (keyup.enter)="onVerifyPinCode()"
                        />
                        <p-button
                          [style]="{ margin: '0 0.2em 0 0.5em' }"
                          styleClass="primary-wcag"
                          tabindex="0"
                          label="OK"
                          ariaLabel="OK"
                          [disabled]="pinCodeCtrl.invalid"
                          (click)="onVerifyPinCode()"
                        />
                        <p-button severity="danger" [tabindex]="0" [ariaLabel]="'shared.Cancel' | translate" [label]="'shared.Cancel' | translate" (click)="toggleEnterPinAreaVisibility()" />
                        @if (verifyingPinCode) {
                          <bi-spinner spinnerSize="small" />
                        }
                        <!-- PIN verification status -->
                        @if (!verifyingPinCode && pinVerified) {
                          <p role="alert" [class]="(pinValid ? 'text-green' : 'bi-color-invalid') + ' font-bold'" translate>
                            {{ pinValid ? "shared.Verified" : "shared.InvalidPin" }}
                          </p>
                        }
                      </div>
                    }
                  </div>
                  <div>
                    @if (currentStep() === 2) {
                      <subscription-overview
                        id="subscription-overview"
                        [mobileEmailName]="mobileEmailForm.value"
                        [(showSubscribeConfirmedText)]="showSubscribeConfirmedText"
                        (onSubscribe)="onSubscribeClicked($event)"
                        (onUnsubscribe)="onUnsubscribe($event)"
                        (onReset)="onReset()"
                      />
                    }
                  </div>
                  @if (currentStep() === 3 && !subscribeBySupplyNumber) {
                    <create-address-subscription (onBack)="backToOverview()" (onCreateSubscription)="createAddressSubscription($event)" />
                  }
                  @if (currentStep() === 3 && subscribeBySupplyNumber && (moduleConfig$ | async).canSubscribeViaSupplyNumber) {
                    <create-supply-number-subscription (onBack)="backToOverview()" (onCreateSubscription)="createSupplyNumberSubscription($event)" />
                  }
                </div>
                @if (moduleConfig$ | async; as moduleConfig) {
                  <p-button
                    [link]="true"
                    [text]="true"
                    id="show-disclaimer-text-button"
                    class="primary-wcag max-w-full ml-2 my-2 block"
                    [tabindex]="0"
                    [ariaLabel]="moduleConfig.showDisclaimerText"
                    [label]="moduleConfig.showDisclaimerText"
                    (click)="onShowDisclaimerChanged(true)"
                  />
                }
              </div>
            </div>
          </main>
          @if (loading) {
            <bi-spinner [hasBackground]="true" [centerInParent]="true" [onTopOfContainer]="true" />
          }
        </div>
      </div>
    </div>

    <!-- DISCLAIMER -->
    @if (showDisclaimer() && moduleConfig$ | async; as moduleConfigModel) {
      <p-card class="disclaimer-card" [@fadeInOut] [cdkTrapFocus]="showDisclaimer()">
        <p-button styleClass="close-icon-button" [text]="true" [rounded]="true" icon="pi pi-times" [tabindex]="0" [ariaLabel]="'shared.Close' | translate" (click)="onShowDisclaimerChanged(false)" />

        <p [innerHTML]="moduleConfigModel.disclaimer"></p>

        <div class="text-center close-button">
          <p-button
            [tabindex]="0"
            [autofocus]="true"
            [ariaLabel]="'shared.Close' | translate"
            styleClass="primary-wcag"
            [label]="'shared.Close' | translate"
            (click)="onShowDisclaimerChanged(false)"
          />
        </div>
      </p-card>
    }
  }

  <!-- Message to display if there's no customer public ID Guid in URL params -->
  @if (customerGuidMissing) {
    <p-card>
      <div class="text-center" role="alert" aria-atomic="true" translate>
        <i class="fas fa-exclamation-triangle bi-color-invalid"></i>
        shared.CustomerGuidMissing
        <i class="fas fa-exclamation-triangle bi-color-invalid"></i>
      </div>
    </p-card>
  }
} @else {
  <bi-spinner spinnerSize="large" [onTopOfContainer]="true" [centerInParent]="true" />
}

<bi-confirm-dialog />
